import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Button, Icon, Table, TableCell, TableBody, TableHead, TableRow, useAuthenticator, Heading } from '@aws-amplify/ui-react';
import { s3ListFlatObjects, s3GenDownloadLink } from '../components/s3Utils';
import { Container } from 'react-bootstrap';
// import background from '../components/assets/table-2879213_1920.jpg';
import { DatumToString } from '../components/lib/DatumToString';
import { istMitarbeiter, verifiedUser } from '../components/utils';

const Information = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [daten, setDaten] = useState()
    const verified = verifiedUser(user);

    const IconSave = () => {
        return (
          <Icon
            ariaLabel=""
            pathData="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z"
          />
        );
      };

    const handleS3InformationList = (response) => {
        // console.log('handleS3InformationList:', (response.files[0].key).split('/').pop())
        
        setDaten(response.files);
        // console.log(response.files)
    }

    const download = (file)  => {
        // console.log(file);
        s3GenDownloadLink(file)
    }

    useEffect(() => {
        if (!daten) {
            const mitarbeiter = istMitarbeiter(user);
            if (mitarbeiter !== undefined) {
                    // console.log('Mitarbeiter:', mitarbeiter)
                    s3ListFlatObjects((mitarbeiter ? 'MitarbeiterInfo/' : 'PatientenInfo/'), 'public', handleS3InformationList);
            }
        }
        // console.log('useEffect called in Menues... isLoaded', daten, speiseplan, isLoaded)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (!user || !verified) {
        // console.log('User, verified', user, verified)
        return (<Navigate to='/profile' replace={true} />)
    }

//    console.log('daten:', daten)
//    style={{ backgroundImage: `url(${background})`, height:'100vh', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
    return (
        <Container className='left-template' >
        {daten &&
                <>
                <Heading level={2} style={{textAlign: "center"}} padding={20}>Informationen zum Herunterladen</Heading>
                <Table
                    caption={`${daten.length} Datei${daten.length !== 1 ? 'en' : ''} zum Herunterladen`}
                    highlightOnHover={true}
                    size='large'
                    variation='striped'
                >
                    <TableHead>
                        <TableRow>
                            <TableCell as="th">Datei</TableCell>
                            <TableCell as="th">vom</TableCell>
                            <TableCell as="th">Größe</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {daten.map((item, i) => {
                            const theDate = DatumToString(item.lastModified);
                            return (
                            <TableRow key={`r_${i}`}>
                                <TableCell><Button gap="0.1rem" onClick={() => download(item.key)} size="large"><IconSave /> {item.key.split('/').pop()}</Button></TableCell>
                                <TableCell>{theDate}</TableCell>
                                <TableCell>{item.size}</TableCell>
                            </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                </>
            }
        </Container>
    )
}

export default Information;
